export default {
      id: "lozenge-usage",
      viewBox: "0 0 22 30",
      url: __webpack_public_path__ + "icons.svg#lozenge",
      toString: function () {
        return this.url;
      }
    }